module.exports = __webpack_public_path__ + "img/about-us-1.14068f34.jpg";